var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, useContext, createElement, Children } from "react";
import { ContentPlaceholder } from "./content-placeholder";
export const ContentMapper = {
    identity: {
        map: (x) => x,
        reverseMap: (x) => x,
    }
};
export const ContentType = {
    rich: () => ({
        name: 'content',
        placeholder: ContentPlaceholder.rich(),
        validator: x => typeof x === 'string'
    }),
    list: ({ elementType }) => ({
        name: elementType.name + ' list',
        placeholder: () => [],
        elementType,
        validator: x => Array.isArray(x) && x.every(elementType.validator)
    }),
    tagged: ({ tag, name = tag, placeholder = (seed) => ({}) }) => ({
        name,
        placeholder: (seed) => (Object.assign({}, placeholder(seed), { type: tag })),
        validator: x => x && x.type === tag,
    })
};
export const placeholderContent = (type, seed = 0) => type.placeholder(seed);
export const ContentContext = createContext(undefined);
export const ProvideContent = (_a) => {
    var { children } = _a, value = __rest(_a, ["children"]);
    return createElement(ContentContext.Provider, { value }, ...Children.toArray(children));
};
export const useContent = () => useContext(ContentContext);
//# sourceMappingURL=content.js.map